import { Driver } from '../../../../../types'

export type MissingField = {
  key: keyof Driver
  label: string
}

export const GetMissingMandatoryFields = (driver: Driver): MissingField[] => {
  const missing: MissingField[] = []

  const required: MissingField[] = [
    { key: 'name', label: 'Navn' },
    { key: 'phoneNo', label: 'Telefon' },
    { key: 'email', label: 'E-post' },
  ]

  for (const info of required) {
    const value = driver[info.key]
    if (value === null || value === undefined || value === '') {
      missing.push(info)
    }
  }

  return missing
}
